"use client";
import { createContext, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../utility/apiInstance";
import { ChargeRateMappingType, extractChargeRateInfo } from "./ManageOrganization/Managecredits/manangeCreditType";

const MyContext = createContext(null) as any;

interface CHARGERATE {
  awbRate: number,
  containerRate: number,
}

export type TrackingData = {
  airline: string;
  origin: string;
  destination: string;

  pkts: number;
  weight: number;

  type: string;
  mawb: string;

  awbLocked: boolean;
  isNullAwb: boolean;
  isOnline: boolean;

  uniqueValue: string;
  customerName: string;
};
type GROUPPEDBY = {
  customFieldByPrefrence: string | "",
  grouppedByPrefrence: string | "",

}

const ManageContextProvider = ({ children }: any) => {
  const [role, setRole] = useState("");
  const [module, setModule] = useState([]) as any;
  const [loading, setLoading] = useState(false);
  const [globleCustomerId, setGlobleCustomerId] = useState("") as any;
  const [organizationId, setOrganizationId] = useState("") as any;
  const [unreadCount, setUnreadCount] = useState(0);
  const [globalData, setGlobalData] = useState<number>(3);
  const [availableCredit, setAvailabeCredit] = useState<number>(0.00);
  const [chargeRate, setChargeRate] = useState<CHARGERATE>({
    awbRate: 0.0,
    containerRate: 0.0,
  });
  const [masterCustomFields, setCustomFields] = useState<any>([])
  const [trackingData, setTrackingData] = useState<TrackingData>({
    airline: "",
    origin: "",
    destination: "",

    pkts: 0,
    weight: 0,

    type: "",
    mawb: "",

    awbLocked: false,
    isNullAwb: false,
    isOnline: false,

    uniqueValue: "",
    customerName: "",
  });
  const [isWebhookAllowed, setIsWebhookAllowed] = useState<boolean>(false);
  const [grouppedByPrefrence, setGrouppedByPrefrence] = useState<GROUPPEDBY>({
    grouppedByPrefrence: "",
    customFieldByPrefrence: ""

  });

  const getOrganizationDetails = async () => {
    try {
      const endpoint = `/api/v1/organisation/getById/${organizationId}`;
      const response = await axiosInstance.get(endpoint);

      const chargeRateWithOrg: ChargeRateMappingType =
        extractChargeRateInfo(response.data.data);

      setChargeRate({
        awbRate: Number(chargeRateWithOrg?.awbRate) || 0.0,
        containerRate: Number(chargeRateWithOrg?.containerRate) || 0.0,
      });
      // setIsWebhookAllowed(response?.data?.data?.isWebhookAllowed || false);
    } catch (error) {
      setChargeRate({
        awbRate: 0.0,
        containerRate: 0.0,
      });
    }
  };

  useEffect(() => {

    if (role === "customeruser" || role === "customeradmin") {
      getOrganizationDetails();
      unreadReadCount();
      fetchCustomFields()

    }
  }, [unreadCount, role]);

  async function unreadReadCount() {
    try {
      const response = await axiosInstance.get(
        "/api/v1/dashboard/unreadReadCount"
      );
      setUnreadCount(response?.data?.data?.unRead);
    } catch (err) {
      setUnreadCount(0);
    }
  }

  const fetchCustomFields = async () => {
    try {
      const { data } = await axiosInstance.get('/api/v1/custom-form/admin-fields');
      setCustomFields(data?.data || []);
    } catch (error: any) {
      setCustomFields([]);
    }
  };

  return (
    <MyContext.Provider
      value={{
        organizationId,
        setOrganizationId,
        globleCustomerId,
        setGlobleCustomerId,
        role,
        loading,
        setRole,
        setLoading,
        unreadCount,
        setUnreadCount,
        unreadReadCount,
        module,
        setModule,
        globalData,
        setGlobalData,
        setAvailabeCredit,
        availableCredit,
        chargeRate,
        setChargeRate,
        masterCustomFields,
        trackingData,
        setTrackingData,
        isWebhookAllowed,
        setIsWebhookAllowed,
        grouppedByPrefrence,
        setGrouppedByPrefrence
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default ManageContextProvider;

export const useRole = () => {
  return useContext(MyContext);
};
